import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LocationStrategy, CommonModule, HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ModalModule } from 'ngx-bootstrap/modal'
import { NgxLoadingModule, ngxLoadingAnimationTypes} from 'ngx-loading';
import { StorageServiceModule } from 'angular-webstorage-service';
//import { BnNgIdleService } from 'bn-ng-idle';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgxPaginationModule } from 'ngx-pagination';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MatPaginatorModule,  MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule,  } from '@angular/material/input';
import { MatSortModule, } from '@angular/material/sort';

import { ToastrModule } from 'ngx-toastr'

import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxUploadModule } from '@wkoza/ngx-upload';
//import { NgxDropzoneModule } from '../../ngx-dropzone/src/public_api';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';
import { PaginatorEspañol } from '../app/PaginatorEspañol';
// Import containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';

import { LoginResetComponent } from './views/login/loginProveedor/loginReset.component';
import { LoginAdminResetComponent } from './views/login/loginAdmin/loginAdminReset.component';
import { LoginComponent } from './views/login/loginProveedor/login.component';
import { LoginAdminComponent } from './views/login/loginAdmin/loginAdmin.component';
import { ModalsComponent } from './views/notifications/modals.component';
import { RegisterComponent } from './views/register/register.component';
import { ngxDropTargetOptions } from '../app/constantes';
import { GlobalErrorHandler } from './servicio/config/GlobalErrorHandler';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { ServerErrorInterceptor } from '@services/config/ServerErrorInterceptor';
import { environment } from '../environments/environment';

// 1. Import the libs you need
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';


@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgxDropzoneModule,
    NgxUploadModule.forRoot(ngxDropTargetOptions),
    HttpClientModule,
    MatTableModule,
    MatPaginatorModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,
    MatSortModule,
    MatInputModule,
    FullCalendarModule ,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AppBreadcrumbModule.forRoot(),
    ModalModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 4000,
      progressBar:true,
      closeButton:true,
      tapToDismiss: false,
      positionClass:'toast-bottom-right', 
      
    }),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    StorageServiceModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    TabsModule.forRoot(),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.threeBounce,
      backdropBorderRadius: '3px',
      primaryColour: '#2d915d',
      secondaryColour: '#0f6faf'
    }),
    ChartsModule,

  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    LoginAdminComponent,
    LoginAdminResetComponent,
    LoginResetComponent,
    ModalsComponent,
    RegisterComponent
  ],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy,
  },
  {
    provide: MatPaginatorIntl,
    useClass: PaginatorEspañol
  },
  { provide: ErrorHandler, useClass: GlobalErrorHandler },
  { provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true }
],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  //providers: [BnNgIdleService],
  bootstrap: [AppComponent]
})
export class AppModule { }
